const validacion = (input) => {
  let errors = {};

  if (!input.nombre) {
    errors.nombre = "El campo nombre no tiene un valor";
  } else if (!/^([A-Za-z])+$/.test(input.name)) {
    errors.name = "El nombre es invalido, solo letras son permitidas";
  }

  if (!input.email) {
    errors.email = "Debe escribir un correo electronico";
  } else if (
    !/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(
      input.email
    )
  ) {
    errors.email = "Correo invalido";
  }

  if(!input.subject){
    errors.subject = "Este campo no puede estar vacio, por favor, escrie un tema a tratar"
  }

  if(!input.mensaje){
    errors.mensaje = "El mensaje no puede enviarse vacio"
  }

  return errors;
};

export default validacion;